import { create } from 'zustand';
import type { Group } from '@ext-bookmark/shared/types';

interface GroupState {
  groups: Group[];
  selectedGroupId: string | null;
  lastUsedGroupId: string | null;
  
  // Actions
  setGroups: (groups: Group[]) => void;
  addGroup: (group: Group) => void;
  updateGroup: (id: string, updates: Partial<Group>) => void;
  deleteGroup: (id: string) => void;
  setSelectedGroupId: (id: string | null) => void;
  setLastUsedGroupId: (id: string | null) => void;
}

export const useGroupStore = create<GroupState>((set) => ({
  groups: [],
  selectedGroupId: null,
  lastUsedGroupId: null,
  
  setGroups: (groups) => set({ groups }),
  addGroup: (group) => set((state) => ({ groups: [...state.groups, group] })),
  updateGroup: (id, updates) => set((state) => ({
    groups: state.groups.map((g) => (g.id === id ? { ...g, ...updates } : g)),
  })),
  deleteGroup: (id) => set((state) => ({
    groups: state.groups.filter((g) => g.id !== id),
  })),
  setSelectedGroupId: (id) => set({ selectedGroupId: id }),
  setLastUsedGroupId: (id) => set({ lastUsedGroupId: id }),
}));
